<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3213_102229)">
<rect x="1.85" y="4.76473" width="18.3" height="12.4705" rx="2.15" stroke="currentColor" stroke-width="1.7"/>
<rect x="4.93439" y="10.3" width="7.32415" height="1.4" rx="0.7" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3213_102229">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
